/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sub_Sport_IndoorInputs */

const en_ui_sub_sport_indoor = /** @type {(inputs: Ui_Sub_Sport_IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indoor`)
};

const de_ui_sub_sport_indoor = /** @type {(inputs: Ui_Sub_Sport_IndoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indoor`)
};

/**
* | output |
* | --- |
* | "Indoor" |
*
* @param {Ui_Sub_Sport_IndoorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sub_sport_indoor = /** @type {((inputs?: Ui_Sub_Sport_IndoorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sub_Sport_IndoorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sub_sport_indoor(inputs)
	return de_ui_sub_sport_indoor(inputs)
});